<section class="events-in-process-section">
  <eventq-lined-tab label="Events In Process" [count]="totalCount()" />
  <eventq-data-table
    [columns]="columns"
    [rows]="inProcess.value()?.items ?? []"
    [sort]="sort()"
    [loading]="inProcess.isLoading() && !inProcess.hasValue()"
    [skeletonCount]="5"
    [showLabelWhenEmpty]="true"
    emptyLabel="No events in process"
    [rowInteractive]="false"
    (sortChange)="onSort($event)"
  />
</section>
